import useSWRImmutable from "swr/immutable";

import { STEP_API_ENDPOINT, swrFetcher } from "../../utils/swr";

export type DisplayCurrencyDecimalsMap = {
  [displayCurrency: string]: number;
};

export type ExchangeRateMap = {
  [displayCurrency: string]: number;
};

type ExchangeRatesResponse = {
  fiat: {
    displayCurrencies: DisplayCurrencyDecimalsMap;
    exchangeRates: ExchangeRateMap;
  };
  crypto: {
    displayCurrencies: DisplayCurrencyDecimalsMap;
  };
};

export const useMarketExchangeRates = () => {
  const { data, mutate: refresh } = useSWRImmutable<ExchangeRatesResponse>(
    `${STEP_API_ENDPOINT}/v1/markets/exchange_rates`,
    swrFetcher,
  );

  let exchangeRates: ExchangeRateMap = { usd: 1 };
  let fiatDisplayCurrencies: DisplayCurrencyDecimalsMap = { USD: 2 };
  let cryptoDisplayCurrencies: DisplayCurrencyDecimalsMap = {};
  if (data) {
    exchangeRates = data.fiat.exchangeRates;
    fiatDisplayCurrencies = data.fiat.displayCurrencies;
    cryptoDisplayCurrencies = data.crypto.displayCurrencies;
  }

  return {
    refresh,
    exchangeRates,
    fiatDisplayCurrencies,
    cryptoDisplayCurrencies,
  };
};
